import { render, staticRenderFns } from "./employee-following-add-conversation-dialog.vue?vue&type=template&id=ee627c76&scoped=true&"
import script from "./employee-following-add-conversation-dialog.vue?vue&type=script&lang=js&"
export * from "./employee-following-add-conversation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee627c76",
  null
  
)

export default component.exports